import React, { FC, type JSX } from "react";

interface IProps {
    promos: JSX.Element[];
}

export const MenuAdverts: FC<IProps> = ({ promos }) => {
    return (
        <div className="main-dropdown-menu__adverts" aria-live="polite">
            {promos}
        </div>
    );
};
